<template>
  <div class="doc fill-white p-24 container-shadow">
    <div class="doc__content row">
      <div class="col-auto text-center">
        <div class="ext-wrapper m-0">
          <img :src="icon" alt="icon" />
        </div>
      </div>
      <div class="col">
        <div class="doc__title">{{ title }}</div>
      </div>
    </div>
    <div class="doc__actions">
      <a :href="link" class="btn btn-outline-primary" target="_blank" rel="noopener">Скачать</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentDocumentCard',
  props: {
    title: { type: String, required: true },
    link: { type: String, required: true },
    icon: { type: String, default: '/pic/icon-doc.svg' }
  }
}
</script>
